<template>
	<modal :show.sync="syncModal" footerClasses="d-none">
		<form-assign-company :assignees="selectedUsers">
			<template #return>
				<base-button
					@click.stop="syncModal = false"
					:disabled="formProcessing"
					type="white"
					size="md"
					class="form-btn bg-transparent px-0 font-weight-normal shadow-none"
					>Cancel</base-button
				>
			</template>
		</form-assign-company>

		<template #footer>
			<div class="sr-only"></div>
		</template>
	</modal>
</template>

<script>
import FormAssignCompany from "@components/FormAssignCompany";

export default {
	name: "modal-assign-company",
	components: {
		FormAssignCompany,
	},
	data() {
		return {
			syncModal: false,
			formProcessing: false,
			selectedUsers: [],
		};
	},
	mounted() {
		this.$bus.trackEvent("toggle-modal", (payload) => {
			if ("assign-company" === payload.key) {
				this.syncModal = payload.active;

				if ("undefined" !== typeof payload.selected)
					this.selectedUsers = [payload.selected];
			}
		});

		this.$bus.trackEvent("datatable-selection-changed", (payload) => {
			this.selectedUsers = payload;
		});

		this.$bus.trackEvent("assign-company-form-processing", (payload) => {
			this.syncModal = payload;
			this.formProcessing = payload;
		});
	},
};
</script>
